export const showLoadingOverlaySelector = state => {
  return !!state && !!state.common && !!state.common.loadersNumber;
};